import React, {useEffect, useRef, useState} from 'react';
import {Box, Button, Paper} from "@mui/material";
import DetailTable from "../../../../components/UI/table/cutting/details/DetailTable";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import DetailService from "../../../../API/orders/cutting/detail/DetailService";
import MaterialWarehouseTable
    from "../../../../components/UI/table/warehouse/material/materialwarehouse/MaterialWarehouseTable";
import MaterialWarehouseService from "../../../../API/orders/warehouse/material/MaterialWarehouseService";
import Typography from "@mui/material/Typography";
import ReservationTableCuttingItem
    from "../../../../components/UI/table/warehouse/reservation/ReservationTableCuttingItem";
import WorkingCuttingMapService from "../../../../API/orders/cutting/cuttingmap/WorkingCuttingMapService";
import CuttingMapDataObjectService from "../../../../API/orders/cutting/cuttingmap/CuttingMapDataObjectService";
import * as Dimensions from "../../../../data/Dimensions";
import SupplierService from "../../../../API/orders/warehouse/supplier/SupplierService";
import CuttingModule from "../../../../components/UI/modul/CuttingModule";
import SettingsCuttingModule from "../../../../components/UI/modul/cuttingmodule/SettingsCuttingModule";
import SettingsCutOffCuttingModule from "../../../../components/UI/modul/cuttingmodule/SettingsCutOffCuttingModule";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import ButtonCreate from "../../../../components/UI/button/ButtonCreate";
import {ButtonGroupTabBar} from "../../../../components/UI/button/ButtonGroupTabBar";
import CheckIcon from "@mui/icons-material/Check";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import {constantsErrorMessages} from "../../../../Constants";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import ButtonSelectAction from "../../../../components/UI/button/ButtonSelectAction";
import {ModalSelectAction} from "../../../../components/UI/modal/ModalSelectAction";
import ModalOpenSetValuesCutOrTurnDetail from "../../../../components/UI/modal/ModalOpenSetValuesCutOrTurnDetail";
import ButtonAdd from "../../../../components/UI/button/ButtonAdd";
import ButtonBlue from "../../../../components/UI/button/ButtonBlue";
import CurrentMapDetails from "../../../../components/UI/table/cutting/details/CurrentMapDetails";
import {withFilter} from "../../../../data/FilterTables/withFilterHOC";
import {DetailFilterData} from "../../../../data/FilterTables/DetailFilterData";
import DetailUtil from "../../../../utils/cutting/DetailUtil";

const ComponentDetailWithFilter = withFilter(DetailTable, DetailFilterData);

const getMaterialOrganizationOptionFromMap = (mapData, materialOId) => {
    for (const order of mapData.orders ?? []) {
        for (const estimate of order.estimates ?? []) {
            for (const unit of estimate.materialEstimateUnits ?? []) {
                const option = unit.materialOrganizationOption;
                if (option?.id == materialOId) {
                    return option;
                }
            }
        }
    }
    return null;
};

const getMaterialFromWorkingCuttingMap = (mapData, materialOId) => {
    const option = getMaterialOrganizationOptionFromMap(mapData, materialOId);
    if (option) {
        return {id: option.id, width: option.width};
    }
    return {id: mapData.materialOId ?? materialOId, width: null};
};

const isCalculationMapState = (workingCuttingMapState) =>
    workingCuttingMapState === 'CALCULATION'
    || workingCuttingMapState === 'CALCULATION_RESERVES_CANCEL'
    || workingCuttingMapState === 'CALCULATION_RESERVES_CREATED'
    || workingCuttingMapState === 'ARCHIVE_CALCULATION';

const applyWorkingCuttingMapState = (workingCuttingMapState, setters) => {
    setters.setIsCalculation(isCalculationMapState(workingCuttingMapState));
    setters.setIsArchive(workingCuttingMapState === 'ARCHIVE');
    setters.setIsCalculationArchive(workingCuttingMapState === 'ARCHIVE_CALCULATION');
    setters.setState(workingCuttingMapState);
    setters.setApproveButton(workingCuttingMapState === 'RESERVES_CREATED');
    setters.setCutButton(
        workingCuttingMapState === 'EXPECTATION'
        || workingCuttingMapState === 'MAPS_CANCEL'
        || workingCuttingMapState === 'CALCULATION'
        || workingCuttingMapState === 'RESERVES_CANCEL'
        || workingCuttingMapState === 'CALCULATION_RESERVES_CANCEL'
    );
    setters.setCancelReserveButton(
        workingCuttingMapState === 'RESERVES_CREATED'
        || workingCuttingMapState === 'CALCULATION_RESERVES_CREATED'
    );
};

const applyDetailsList = (details, setters) => {
    setters.setData(details);
    setters.setTableOptions((prev) => ({...prev, totalElements: details.length}));
    setters.validateCuttingMapDetails?.(details);

    const cutMap = {};
    const turnMap = {};
    details.forEach((row) => {
        cutMap[row.id] = row.cut;
        turnMap[row.id] = row.turn;
    });
    setters.setUnableCut(cutMap);
    setters.setUnableTurn(turnMap);
};

const applyWorkingCuttingMapAuxiliaryData = (mapData, setters) => {
    if (mapData == null || typeof mapData !== 'object') {
        return;
    }
    if (Array.isArray(mapData.notUsedDetails)) {
        setters.setNotUsedDetails(mapData.notUsedDetails);
    }
    if (Array.isArray(mapData.materialReserves)) {
        setters.setDataMaterialReserve(mapData.materialReserves);
    }
};

const WORKING_CUTTING_MAP_SETTINGS_DEFAULTS = {
    trimmingLeft: 20,
    trimmingRight: 20,
    trimmingTop: 20,
    trimmingBottom: 20,
    trimmingLeftCutOff: 10,
    trimmingRightCutOff: 10,
    trimmingTopCutOff: 10,
    trimmingBottomCutOff: 10,
    minBalanceUpToWholeSheet: 0,
    minACutOff: 464,
    minBCutOff: 64,
    limitNumberTurns: 2,
    cutWeight: 4.2,
    cutDefault: 'WHOLE',
    rotatePartInsideStrip: false,
    fitToStripFirst: false,
    fitToStripSecond: false,
    dimensions: Object.keys(Dimensions.dimensions)[0],
    combiningDrops: false,
    cutDropDetail: false,
    cutFitToStripFirstDropDetail: false,
    cutFitToStripSecondDropDetail: false,
    cutCombiningDrops: false,
    takeAccountDimensions: true,
    cutWastes: false,
    cutCutOffs: false,
    cutOnlyCutOffs: false,
    cutOnlyWarehouse: false,
    count: 1,
    percentCutOff: 15,
    percentWaste: 15,
};

const applyCuttingModuleSettingsFromMap = (mapData, setters) => {
    if (mapData.dimensions) {
        setters.setDimensions(mapData.dimensions);
    }
    setters.setFitToStripFirst(mapData.fitToStripFirst ?? false);
    setters.setFitToStripSecond(mapData.fitToStripSecond ?? false);
    setters.setCombiningDrops(mapData.combiningDrops ?? false);
    setters.setCutDropDetail(mapData.cutDropDetail ?? false);
    setters.setCutFitToStripFirstDropDetail(mapData.cutFitToStripFirstDropDetail ?? false);
    setters.setCutFitToStripSecondDropDetail(mapData.cutFitToStripSecondDropDetail ?? false);
    setters.setCutCombiningDrops(mapData.cutCombiningDrops ?? false);
    setters.setTakeAccountDimensions(mapData.takeAccountDimensions ?? true);
    setters.setCutWastes(mapData.cutWastes ?? false);
    setters.setCutCutOffs(mapData.cutCutOffs ?? false);
    setters.setCutOnlyCutOffs(mapData.cutOnlyCutOffs ?? false);
    setters.setCutOnlyWarehouse(mapData.cutOnlyWarehouse ?? false);
};

const buildCuttingModuleSettingsFromMap = (mapData) => ({
    fitToStripFirst: mapData.fitToStripFirst ?? false,
    fitToStripSecond: mapData.fitToStripSecond ?? false,
    dimensions: mapData.dimensions ?? Object.keys(Dimensions.dimensions)[0],
    combiningDrops: mapData.combiningDrops ?? false,
    cutDropDetail: mapData.cutDropDetail ?? false,
    cutFitToStripFirstDropDetail: mapData.cutFitToStripFirstDropDetail ?? false,
    cutFitToStripSecondDropDetail: mapData.cutFitToStripSecondDropDetail ?? false,
    cutCombiningDrops: mapData.cutCombiningDrops ?? false,
    takeAccountDimensions: mapData.takeAccountDimensions ?? true,
    cutWastes: mapData.cutWastes ?? false,
    cutCutOffs: mapData.cutCutOffs ?? false,
    cutOnlyCutOffs: mapData.cutOnlyCutOffs ?? false,
    cutOnlyWarehouse: mapData.cutOnlyWarehouse ?? false,
});

const resolveDefaultSupplierId = (mapData, supplierList, materialOId) => {
    const defaultId = getMaterialOrganizationOptionFromMap(mapData, materialOId)?.defaultSupplier?.id;
    return defaultId ?? supplierList?.[0]?.id ?? null;
};

const resolveSupplierId = (mapData, supplierList, materialOId) => {
    if (mapData.supplier?.id != null) {
        return mapData.supplier.id;
    }
    return resolveDefaultSupplierId(mapData, supplierList, materialOId);
};

const isEmptySettingValue = (value) => value == null || value === '';

const buildWorkingCuttingMapSettings = (mapData, workingCuttingMapId, supplierId, applyDefaults) => {
    const defaults = WORKING_CUTTING_MAP_SETTINGS_DEFAULTS;
    const pick = (value, defaultValue, treatZeroAsEmpty = false) => {
        if (!applyDefaults) {
            return value;
        }
        if (isEmptySettingValue(value) || (treatZeroAsEmpty && value === 0)) {
            return defaultValue;
        }
        return value;
    };

    return {
        workingCuttingMapId,
        supplierId,
        cutDefault: pick(mapData.cutDefault, defaults.cutDefault),
        trimmingLeft: pick(mapData.trimmingLeft, defaults.trimmingLeft),
        trimmingRight: pick(mapData.trimmingRight, defaults.trimmingRight),
        trimmingTop: pick(mapData.trimmingTop, defaults.trimmingTop),
        trimmingBottom: pick(mapData.trimmingBottom, defaults.trimmingBottom),
        trimmingLeftCutOff: pick(mapData.trimmingLeftCutOff, defaults.trimmingLeftCutOff, true),
        trimmingRightCutOff: pick(mapData.trimmingRightCutOff, defaults.trimmingRightCutOff, true),
        trimmingTopCutOff: pick(mapData.trimmingTopCutOff, defaults.trimmingTopCutOff, true),
        trimmingBottomCutOff: pick(mapData.trimmingBottomCutOff, defaults.trimmingBottomCutOff, true),
        minBalanceUpToWholeSheet: pick(mapData.minBalanceUpToWholeSheet, defaults.minBalanceUpToWholeSheet),
        minACutOff: pick(mapData.minLengthCutOff, defaults.minACutOff, true),
        minBCutOff: pick(mapData.minWidthCutOff, defaults.minBCutOff, true),
        limitNumberTurns: pick(mapData.limitNumberTurns, defaults.limitNumberTurns),
        cutWeight: pick(mapData.cutWeight, defaults.cutWeight, true),
        rotatePartInsideStrip: pick(mapData.rotatePartInsideStrip, defaults.rotatePartInsideStrip),
        count: pick(mapData.count, defaults.count),
        percentCutOff: pick(mapData.percentCutOff, defaults.percentCutOff),
        percentWaste: pick(mapData.percentWaste, defaults.percentWaste),
    };
};

const applyWorkingCuttingMapSettings = (settings, mapData, materialOId, setters) => {
    setters.setMaterial(getMaterialFromWorkingCuttingMap(mapData, materialOId));
    setters.setCutDefault(settings.cutDefault);
    setters.setDefaultSupplierId(settings.defaultSupplierId);
    setters.setSupplierId(settings.supplierId);
    setters.setMinBalanceUpToWholeSheet(settings.minBalanceUpToWholeSheet);
    setters.setMinACutOff(settings.minACutOff);
    setters.setMinBCutOff(settings.minBCutOff);
    setters.setCutWeight(settings.cutWeight);
    setters.setLimitNumberTurns(settings.limitNumberTurns);
    setters.setPercentCutOff(settings.percentCutOff);
    setters.setPercentWaste(settings.percentWaste);
    setters.setCount(settings.count);
    setters.setRotatePartInsideStrip(settings.rotatePartInsideStrip);

    const trimming = {
        trimmingLeft: settings.trimmingLeft,
        trimmingRight: settings.trimmingRight,
        trimmingTop: settings.trimmingTop,
        trimmingBottom: settings.trimmingBottom,
    };
    setters.setBaseIndents(trimming);
    setters.setTrimmingLeft(settings.trimmingLeft);
    setters.setTrimmingRight(settings.trimmingRight);
    setters.setTrimmingBottom(settings.trimmingBottom);
    setters.setTrimmingTop(settings.trimmingTop);
    setters.setTrimmingLeftCutOff(settings.trimmingLeftCutOff);
    setters.setTrimmingRightCutOff(settings.trimmingRightCutOff);
    setters.setTrimmingBottomCutOff(settings.trimmingBottomCutOff);
    setters.setTrimmingTopCutOff(settings.trimmingTopCutOff);
};

const buildWorkingCuttingMapUpdatePayload = (settings) => ({
    id: Number(settings.workingCuttingMapId),
    trimmingLeft: settings.trimmingLeft,
    trimmingRight: settings.trimmingRight,
    trimmingTop: settings.trimmingTop,
    trimmingBottom: settings.trimmingBottom,
    trimmingLeftCutOff: settings.trimmingLeftCutOff,
    trimmingRightCutOff: settings.trimmingRightCutOff,
    trimmingTopCutOff: settings.trimmingTopCutOff,
    trimmingBottomCutOff: settings.trimmingBottomCutOff,
    minBalanceUpToWholeSheet: settings.minBalanceUpToWholeSheet,
    minLengthCutOff: settings.minACutOff,
    minWidthCutOff: settings.minBCutOff,
    limitNumberTurns: settings.limitNumberTurns,
    cutWeight: settings.cutWeight,
    cutDefault: settings.cutDefault,
    rotatePartInsideStrip: settings.rotatePartInsideStrip,
    fitToStripFirst: settings.fitToStripFirst,
    fitToStripSecond: settings.fitToStripSecond,
    dimensions: settings.dimensions,
    combiningDrops: settings.combiningDrops,
    cutDropDetail: settings.cutDropDetail,
    cutFitToStripFirstDropDetail: settings.cutFitToStripFirstDropDetail,
    cutFitToStripSecondDropDetail: settings.cutFitToStripSecondDropDetail,
    cutCombiningDrops: settings.cutCombiningDrops,
    takeAccountDimensions: settings.takeAccountDimensions,
    cutWastes: settings.cutWastes,
    cutCutOffs: settings.cutCutOffs,
    cutOnlyCutOffs: settings.cutOnlyCutOffs,
    cutOnlyWarehouse: settings.cutOnlyWarehouse,
    count: settings.count,
    percentCutOff: settings.percentCutOff,
    percentWaste: settings.percentWaste,
});

const buildWorkingCuttingMapSaveKey = (supplierId, settings) => JSON.stringify({
    supplierId,
    ...buildWorkingCuttingMapUpdatePayload(settings),
});

const isValidCuttingMapDataObjectId = (id) =>
    id != null && id !== '' && String(id) !== 'undefined' && String(id) !== 'null';

const WorkingCuttingMapItem = () => {
        const [isLoading, setIsLoading] = useState(true);
        const [rowSelection, setRowSelection] = useState([]);
        const [open, setOpen] = useState(false)
        const pathname = useLocation().pathname
        // Vector is the default; /image/ keeps the legacy PNG renderer available for rollback.
        const vector = !pathname.includes('/image/');
        const [data, setData] = useState([]);
        const [alertData, setAlertData] = useState({});
        const [dataMaterialWarehouse, setDataMaterialWarehouse] = useState([]);
        const [unableCutMaterialWarehouse, setUnableCutMaterialWarehouse] = useState({});

        const [dataMaterialWarehouseCuttingMap, setDataMaterialWarehouseCuttingMap] = useState([]);

        const [isLoadingCuttingMap, setIsLoadingCuttingMap] = useState(false);

        const [images, setImages] = useState([]);
        const [vectorCuttingMap, setVectorCuttingMap] = useState(null);
        const [currentPage, setCurrentPage] = useState(1);
        const [drawEdge, setDrawEdge] = useState(true);

        const [changeCuttingMap, setChangeCuttingMap] = useState(true);
        const [dataMaterialReserve, setDataMaterialReserve] = useState([]);

        const [unableCut, setUnableCut] = useState({});
        const [unableTurn, setUnableTurn] = useState({});
        const [selectedIds, setSelectedIds] = useState([]);
        const [modalStatusOpen, setModalStatusOpen] = useState(false);
        const [status, setStatus] = useState(true);
        const [typeStatus, setTypeStatus] = useState(null);
        const [tab, setTab] = useState(3);
        const [change, setChange] = useState(false);
        const [isError, setIsError] = useState(false);
        const [errorIds, setErrorIds] = useState([]);
        const [state, setState] = useState(null);
        const [cancelReserveButton, setCancelReserveButton] = useState(null);
        const [approveButton, setApproveButton] = useState(null);
        const [cutButton, setCutButton] = useState(null);
        const [currentOrdersCuttingMapDataObjectDetails, setCurrentOrdersCuttingMapDataObjectDetails] = useState([])
        const [notUsedDetails, setNotUsedDetails] = useState([])
        const [currentOrdersCuttingMapDataObjectReserve, setCurrentOrdersCuttingMapDataObjectReserve] = useState([])

        const [supplierList, setSupplierList] = useState(null);
        const [supplierId, setSupplierId] = useState(null);
        const [defaultSupplierId, setDefaultSupplierId] = useState(null);
        const [minBalanceUpToWholeSheet, setMinBalanceUpToWholeSheet] = useState(null);
        const [material, setMaterial] = useState(null);
        const [cutDefault, setCutDefault] = useState(null);

        const [trimmingLeft, setTrimmingLeft] = useState(null);
        const [trimmingRight, setTrimmingRight] = useState(null);
        const [trimmingBottom, setTrimmingBottom] = useState(null);
        const [trimmingTop, setTrimmingTop] = useState(null);

        const [trimmingLeftCutOff, setTrimmingLeftCutOff] = useState(null);
        const [trimmingRightCutOff, setTrimmingRightCutOff] = useState(null);
        const [trimmingBottomCutOff, setTrimmingBottomCutOff] = useState(null);
        const [trimmingTopCutOff, setTrimmingTopCutOff] = useState(null);

        const profile = JSON.parse(localStorage.getItem("profile"))
        const [baseCurrency, setBaseCurrency] = useState(profile?.baseCurAbbreviation);
        const [alternativeCurrency, setAlternativeCurrency] = useState(profile?.alternativeCurAbbreviation);
        const [isCalculation, setIsCalculation] = useState(false);
        const [isArchive, setIsArchive] = useState(false);
        const [isCalculationArchive, setIsCalculationArchive] = useState(false);
        const [tableOptions, setTableOptions] = useState({
            pageIndex: 0,
            pageSize: 100,
            totalElements: 0,
            searchData: ""
        })
        const tableOptionsHandle = (nextState) => {
            setTableOptions(nextState)
            if (nextState.pageSize !== tableOptions.pageSize) {
                EditLocalStoragePagesData(`${pathname}`, "pageSize", nextState.pageSize)
            }
        }

        const [baseIndents, setBaseIndents] = useState({
            trimmingLeft: 20,
            trimmingRight: 20,
            trimmingTop: 20,
            trimmingBottom: 20,
        });

        const [tempBaseIndents, setTempBaseIndents] = useState({
            trimmingLeft: 20,
            trimmingRight: 20,
            trimmingTop: 20,
            trimmingBottom: 20,
        });
        const [cutWeight, setCutWeight] = useState(0);
        const [minACutOff, setMinACutOff] = useState(0);
        const [minBCutOff, setMinBCutOff] = useState(0);

        const [fitToStripFirst, setFitToStripFirst] = useState(false);
        const [fitToStripSecond, setFitToStripSecond] = useState(false);
        const [dimensions, setDimensions] = useState(Object.keys(Dimensions.dimensions)[0]);
        const [combiningDrops, setCombiningDrops] = useState(false);
        const [cutDropDetail, setCutDropDetail] = useState(false);
        const [cutFitToStripFirstDropDetail, setCutFitToStripFirstDropDetail] = useState(false);
        const [cutFitToStripSecondDropDetail, setCutFitToStripSecondDropDetail] = useState(false);
        const [cutCombiningDrops, setCutCombiningDrops] = useState(false);
        const [takeAccountDimensions, setTakeAccountDimensions] = useState(true);
        const [cutWastes, setCutWastes] = useState(false);
        const [cutCutOffs, setCutCutOffs] = useState(false);
        const [limitNumberTurns, setLimitNumberTurns] = useState(2);
        const [rotatePartInsideStrip, setRotatePartInsideStrip] = useState(false);
        const [alternativeServer, setAlternativeServer] = useState(false);
        const [cutOnlyCutOffs, setCutOnlyCutOffs] = useState(false);
        const [cutOnlyWarehouse, setCutOnlyWarehouse] = useState(false);

        const [percentCutOff, setPercentCutOff] = useState(15);
        const [percentWaste, setPercentWaste] = useState(15);
        const [count, setCount] = useState(1);

        const skipSettingsSaveRef = useRef(true);
        const lastSavedSettingsRef = useRef(null);
        const mapRefreshInitializedRef = useRef(false);
        const mapStateRef = useRef(null);
        const detailsFallbackRef = useRef(null);

        const params = useParams();

        const {workingCuttingMapId, nameMaterial, number, materialOId} = params;

        const handleModalAlert = (message, type = "error") => {
            setAlertData({
                type: type,
                open: true,
                message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
            })
        }
        const notUsedDetailsIsEmpty = () => {
            return !(Array.isArray(notUsedDetails) && notUsedDetails.length === 0);
        };

        useEffect(() => {
            getStartPageSize()
        }, [workingCuttingMapId]);

        useEffect(() => {
                MaterialWarehouseService.getAllByMaterialIdForCuttingMap(materialOId).then(function (response) {
                    const data = response.data;
                    setDataMaterialWarehouse(data);
                    data.forEach((row) => {
                        unableCutMaterialWarehouse[row.id] = row.materialPriceUnit.cut;
                    });
                })
                    .catch(function (error) {
                        handleModalAlert(error);
                    });
            }, [changeCuttingMap, materialOId]
        );

        useEffect(() => {
                if (!workingCuttingMapId) {
                    return;
                }
                setIsLoadingCuttingMap(true)
                // Те же запросы, что и на оригинальной странице
                WorkingCuttingMapService.getById(workingCuttingMapId, drawEdge)
                    .then(function (response) {
                        const data = [...(response.data?.cuttingMapDataObject ?? [])]
                            .sort((a, b) => (a.ordered ?? 0) - (b.ordered ?? 0));
                        setDataMaterialWarehouseCuttingMap(data);
                        setCurrentPage(1);
                        if (data.length !== 0) {
                            setCurrentOrdersCuttingMapDataObjectDetails(data[0]?.pieces);
                            setCurrentOrdersCuttingMapDataObjectReserve(data[0]?.materialReserves);
                        } else {
                            setCurrentOrdersCuttingMapDataObjectDetails([]);
                            setCurrentOrdersCuttingMapDataObjectReserve([]);
                        }
                        if (vector) {
                            setImages([]);
                            // Пустой массив = карта ещё не раскроена, рисовать нечего
                            if (data.length === 0) {
                                setVectorCuttingMap(null);
                                setIsLoadingCuttingMap(false);
                            }
                            // иначе loading снимет эффект get-json после загрузки листа
                            return;
                        }
                        const nextImages = data.map((item) => {
                            const image = new Image();
                            image.src = item.base64Image
                                ? 'data:image/png;base64,' + item.base64Image
                                : '';
                            return image;
                        });
                        setImages(nextImages);
                        setIsLoadingCuttingMap(false)
                    })
                    .catch(function (error) {
                        handleModalAlert(error);
                        setIsLoadingCuttingMap(false)
                    })
            },
            [changeCuttingMap, workingCuttingMapId, drawEdge, vector]
        );

        // Vector: get-json только если cuttingMapDataObject не пуст и у листа есть id
        useEffect(() => {
            if (!vector) {
                return;
            }
            if (!dataMaterialWarehouseCuttingMap.length) {
                setVectorCuttingMap(null);
                setIsLoadingCuttingMap(false);
                return;
            }
            const sheet = dataMaterialWarehouseCuttingMap[currentPage - 1];
            const sheetId = sheet?.id;
            if (!isValidCuttingMapDataObjectId(sheetId)) {
                setVectorCuttingMap(null);
                setIsLoadingCuttingMap(false);
                return;
            }
            let cancelled = false;
            setIsLoadingCuttingMap(true);
            CuttingMapDataObjectService.getJson(sheetId)
                .then(function (response) {
                    if (cancelled) {
                        return;
                    }
                    const json = response.data?.cuttingMap ?? response.data;
                    setVectorCuttingMap(json ?? null);
                })
                .catch(function (error) {
                    if (cancelled) {
                        return;
                    }
                    setVectorCuttingMap(null);
                    handleModalAlert(error);
                })
                .finally(function () {
                    if (!cancelled) {
                        setIsLoadingCuttingMap(false);
                    }
                });
            return () => {
                cancelled = true;
            };
        }, [vector, currentPage, dataMaterialWarehouseCuttingMap]);

        useEffect(() => {
            if (dataMaterialWarehouseCuttingMap.length !== 0) {
                setCurrentOrdersCuttingMapDataObjectDetails(dataMaterialWarehouseCuttingMap[currentPage - 1]?.pieces);
                setCurrentOrdersCuttingMapDataObjectReserve(dataMaterialWarehouseCuttingMap[currentPage - 1]?.materialReserves);
            }
        }, [currentPage, dataMaterialWarehouseCuttingMap, workingCuttingMapId]);

        const navigate = useNavigate();

        const mapStateSetters = {
            setIsCalculation,
            setIsArchive,
            setIsCalculationArchive,
            setState,
            setApproveButton,
            setCutButton,
            setCancelReserveButton,
        };

        const settingsSetters = {
            setMaterial,
            setCutDefault,
            setDefaultSupplierId,
            setSupplierId,
            setMinBalanceUpToWholeSheet,
            setMinACutOff,
            setMinBCutOff,
            setCutWeight,
            setLimitNumberTurns,
            setPercentCutOff,
            setPercentWaste,
            setCount,
            setRotatePartInsideStrip,
            setBaseIndents,
            setTrimmingLeft,
            setTrimmingRight,
            setTrimmingBottom,
            setTrimmingTop,
            setTrimmingLeftCutOff,
            setTrimmingRightCutOff,
            setTrimmingBottomCutOff,
            setTrimmingTopCutOff,
        };

        const cuttingModuleSetters = {
            setDimensions,
            setFitToStripFirst,
            setFitToStripSecond,
            setCombiningDrops,
            setCutDropDetail,
            setCutFitToStripFirstDropDetail,
            setCutFitToStripSecondDropDetail,
            setCutCombiningDrops,
            setTakeAccountDimensions,
            setCutWastes,
            setCutCutOffs,
            setCutOnlyCutOffs,
            setCutOnlyWarehouse,
        };

        const validateCuttingMapDetails = (details) => {
            const rows = Array.isArray(details) ? details : [];
            const duplicatePositions = DetailUtil.checkDuplicatePositions(rows, false);
            setIsError(duplicatePositions.length > 0);
            setErrorIds(duplicatePositions);
        };

        const detailsSetters = {
            setData,
            setTableOptions,
            setUnableCut,
            setUnableTurn,
            setNotUsedDetails,
            setDataMaterialReserve,
            validateCuttingMapDetails,
        };

        const enableSettingsSave = () => {
            window.setTimeout(() => {
                skipSettingsSaveRef.current = false;
            }, 0);
        };

        const applyMapDataFromResponse = (mapData, suppliers, persistDefaults) => {
            const supplierIdFromMap = mapData.supplier?.id ?? null;
            const materialDefaultSupplierId = resolveDefaultSupplierId(mapData, suppliers, materialOId);
            const resolvedSupplierId = resolveSupplierId(mapData, suppliers, materialOId);
            const cuttingModuleSettings = buildCuttingModuleSettingsFromMap(mapData);
            const rawSettings = buildWorkingCuttingMapSettings(
                mapData,
                workingCuttingMapId,
                supplierIdFromMap,
                false
            );
            const normalizedSettings = buildWorkingCuttingMapSettings(
                mapData,
                workingCuttingMapId,
                resolvedSupplierId,
                true
            );

            applyWorkingCuttingMapSettings({
                ...normalizedSettings,
                defaultSupplierId: materialDefaultSupplierId,
                supplierId: resolvedSupplierId,
            }, mapData, materialOId, settingsSetters);
            setAlternativeServer(mapData.alternativeServer ?? false);
            applyCuttingModuleSettingsFromMap(mapData, cuttingModuleSetters);
            detailsFallbackRef.current = mapData.details ?? null;
            if (Array.isArray(mapData.details) && mapData.details.length > 0) {
                applyDetailsList(mapData.details, detailsSetters);
            }
            applyWorkingCuttingMapAuxiliaryData(mapData, detailsSetters);
            // details: только из getState → tryLoadCuttingMapDetails (иначе дубль for-cutting-map)

            const settingsForSave = {
                ...normalizedSettings,
                ...cuttingModuleSettings,
            };
            const normalizedSaveKey = buildWorkingCuttingMapSaveKey(resolvedSupplierId, settingsForSave);

            const finishLoad = () => {
                lastSavedSettingsRef.current = normalizedSaveKey;
                enableSettingsSave();
            };

            if (!persistDefaults || resolvedSupplierId == null) {
                finishLoad();
                return Promise.resolve();
            }

            const rawSettingsForSave = {
                ...rawSettings,
                ...cuttingModuleSettings,
            };
            const rawSaveKey = buildWorkingCuttingMapSaveKey(supplierIdFromMap, rawSettingsForSave);
            if (rawSaveKey === normalizedSaveKey) {
                finishLoad();
                return Promise.resolve();
            }

            return WorkingCuttingMapService.update(
                workingCuttingMapId,
                resolvedSupplierId,
                buildWorkingCuttingMapUpdatePayload(settingsForSave)
            )
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(finishLoad);
        };

        const applyCuttingMapTabDataFromResponse = (mapData) => {
            applyCuttingModuleSettingsFromMap(mapData, cuttingModuleSetters);
            detailsFallbackRef.current = mapData.details ?? null;
            if (Array.isArray(mapData.details) && mapData.details.length > 0) {
                applyDetailsList(mapData.details, detailsSetters);
            }
            applyWorkingCuttingMapAuxiliaryData(mapData, detailsSetters);
            // for-cutting-map только из эффекта getState (changeCuttingMap), без второго вызова здесь
        };

        const loadCuttingMapDetails = (calculation) => {
            if (!workingCuttingMapId) {
                return;
            }
            DetailService.getForCuttingMap(workingCuttingMapId, calculation ? true : undefined)
                .then(function (response) {
                    const details = response.data ?? [];
                    const list = details.length > 0 ? details : (detailsFallbackRef.current ?? []);
                    applyDetailsList(list, detailsSetters);
                })
                .catch(function (error) {
                    if (detailsFallbackRef.current?.length) {
                        const list = detailsFallbackRef.current;
                        applyDetailsList(list, detailsSetters);
                        return;
                    }
                    handleModalAlert(error);
                });
        };

        const tryLoadCuttingMapDetails = () => {
            if (mapStateRef.current == null) {
                return;
            }
            loadCuttingMapDetails(isCalculationMapState(mapStateRef.current));
        };

        useEffect(() => {
            validateCuttingMapDetails(data);
        }, [data]);

        const approve = async () => {
            setIsLoadingCuttingMap(true)
            WorkingCuttingMapService.approveCuttingMap(workingCuttingMapId)
                .then(function () {
                    setIsLoadingCuttingMap(false)
                    applyWorkingCuttingMapState('MAPS_APPROVED', mapStateSetters);
                    setChangeCuttingMap(!changeCuttingMap)
                    handleModalAlert("Карта раскроя подтверждена", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                    setIsLoadingCuttingMap(false)
                })
        }

        const cancelReserve = async () => {
            setIsLoadingCuttingMap(true)
            WorkingCuttingMapService.cancelReserve(workingCuttingMapId)
                .then(function () {
                    setIsLoadingCuttingMap(false);
                    const nextState = state === 'CALCULATION_RESERVES_CREATED'
                        ? 'CALCULATION_RESERVES_CANCEL'
                        : 'RESERVES_CANCEL';
                    applyWorkingCuttingMapState(nextState, mapStateSetters);
                    setChangeCuttingMap(!changeCuttingMap);
                    setCurrentOrdersCuttingMapDataObjectDetails([]);
                    setCurrentOrdersCuttingMapDataObjectReserve([]);
                    handleModalAlert("Резервы отменены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                    setIsLoadingCuttingMap(false)
                })
        }

        const cancel = async () => {
            setIsLoadingCuttingMap(true)
            WorkingCuttingMapService.cancelCuttingMap(workingCuttingMapId)
                .then(function () {
                    setIsLoadingCuttingMap(false);
                    applyWorkingCuttingMapState('MAPS_CANCEL', mapStateSetters);
                    setChangeCuttingMap(!changeCuttingMap);
                    setCurrentOrdersCuttingMapDataObjectDetails([]);
                    setCurrentOrdersCuttingMapDataObjectReserve([]);
                    handleModalAlert("Карта раскроя отменена", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                    setIsLoadingCuttingMap(false)
                })
        }

        useEffect(() => {
            mapRefreshInitializedRef.current = false;
            mapStateRef.current = null;
            detailsFallbackRef.current = null;
        }, [workingCuttingMapId]);

        useEffect(() => {
            skipSettingsSaveRef.current = true;
            setIsLoading(true);
            Promise.all([
                WorkingCuttingMapService.getById(workingCuttingMapId),
                SupplierService.get(),
            ]).then(function ([mapResponse, supplierResponse]) {
                setSupplierList(supplierResponse.data);
                return applyMapDataFromResponse(mapResponse.data, supplierResponse.data, true);
            })
                .catch(function (error) {
                    handleModalAlert(error);
                    enableSettingsSave();
                })
                .finally(() => setIsLoading(false));
        }, [workingCuttingMapId, materialOId]);

        useEffect(() => {
            WorkingCuttingMapService.getState(workingCuttingMapId).then(function (response) {
                mapStateRef.current = response.data;
                applyWorkingCuttingMapState(response.data, mapStateSetters);
                tryLoadCuttingMapDetails();
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }, [changeCuttingMap, workingCuttingMapId]);

        useEffect(() => {
            if (!mapRefreshInitializedRef.current) {
                mapRefreshInitializedRef.current = true;
                return;
            }
            skipSettingsSaveRef.current = true;
            WorkingCuttingMapService.getById(workingCuttingMapId).then(function (response) {
                applyCuttingMapTabDataFromResponse(response.data);
                enableSettingsSave();
            })
                .catch(function (error) {
                    handleModalAlert(error);
                    enableSettingsSave();
                });
        }, [changeCuttingMap, workingCuttingMapId]);

        const buildCurrentSettingsForSave = (currentSupplierId) => ({
            workingCuttingMapId,
            cutDefault,
            trimmingLeft,
            trimmingRight,
            trimmingTop,
            trimmingBottom,
            trimmingLeftCutOff,
            trimmingRightCutOff,
            trimmingTopCutOff,
            trimmingBottomCutOff,
            minBalanceUpToWholeSheet,
            minACutOff,
            minBCutOff,
            limitNumberTurns,
            cutWeight,
            rotatePartInsideStrip,
            count,
            percentCutOff,
            percentWaste,
            fitToStripFirst,
            fitToStripSecond,
            dimensions,
            combiningDrops,
            cutDropDetail,
            cutFitToStripFirstDropDetail,
            cutFitToStripSecondDropDetail,
            cutCombiningDrops,
            takeAccountDimensions,
            cutWastes,
            cutCutOffs,
            cutOnlyCutOffs,
            cutOnlyWarehouse,
        });

        const persistSettingsIfChanged = (currentSupplierId) => {
            if (currentSupplierId == null || cutDefault == null) {
                return Promise.resolve();
            }
            const settings = buildCurrentSettingsForSave(currentSupplierId);
            const saveKey = buildWorkingCuttingMapSaveKey(currentSupplierId, settings);
            if (saveKey === lastSavedSettingsRef.current) {
                return Promise.resolve();
            }
            return WorkingCuttingMapService.update(
                workingCuttingMapId,
                currentSupplierId,
                buildWorkingCuttingMapUpdatePayload(settings)
            ).then(function (response) {
                lastSavedSettingsRef.current = saveKey;
                if (response?.data) {
                    applyWorkingCuttingMapAuxiliaryData(response.data, detailsSetters);
                }
            });
        };

        useEffect(() => {
            if (skipSettingsSaveRef.current) {
                return;
            }
            const currentSupplierId = supplierId ?? defaultSupplierId;
            persistSettingsIfChanged(currentSupplierId)
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }, [
            workingCuttingMapId,
            supplierId,
            defaultSupplierId,
            cutDefault,
            trimmingLeft,
            trimmingRight,
            trimmingTop,
            trimmingBottom,
            trimmingLeftCutOff,
            trimmingRightCutOff,
            trimmingTopCutOff,
            trimmingBottomCutOff,
            minBalanceUpToWholeSheet,
            minACutOff,
            minBCutOff,
            limitNumberTurns,
            cutWeight,
            rotatePartInsideStrip,
            percentCutOff,
            percentWaste,
            count,
            fitToStripFirst,
            fitToStripSecond,
            dimensions,
            combiningDrops,
            cutDropDetail,
            cutFitToStripFirstDropDetail,
            cutFitToStripSecondDropDetail,
            cutCombiningDrops,
            takeAccountDimensions,
            cutWastes,
            cutCutOffs,
            cutOnlyCutOffs,
            cutOnlyWarehouse,
        ]);

        const cutting = async () => {
            setIsLoadingCuttingMap(true)
            const currentSupplierId = supplierId === null ? defaultSupplierId : supplierId;
            try {
                await persistSettingsIfChanged(currentSupplierId);
                const response = await WorkingCuttingMapService.cut(
                    workingCuttingMapId,
                    null,
                    null,
                    alternativeServer,
                );
                const mapData = response?.data;
                if (mapData != null && typeof mapData === 'object') {
                    applyCuttingMapTabDataFromResponse(mapData);
                }
                if (!Array.isArray(mapData?.notUsedDetails)) {
                    const refreshed = await WorkingCuttingMapService.getById(workingCuttingMapId);
                    applyWorkingCuttingMapAuxiliaryData(refreshed?.data, detailsSetters);
                }
                setIsLoadingCuttingMap(false);
                setChangeCuttingMap(!changeCuttingMap);
            } catch (error) {
                handleModalAlert(error);
                setIsLoadingCuttingMap(false);
            }
        }
        const getStartPageSize = () => {
            const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
            const savedTab = pagesData[pathname]?.tab
            savedTab && setTab(savedTab)
            // getTabsData(savedTab, true)
        }
        const handleChangeTab = (tab) => {
            setTab(tab)
            setRowSelection([])
            EditLocalStoragePagesData(pathname, "tab", tab)
        }
        const setTitleModalOpenMethod = (typeStatus) => {
            return typeStatus === "cut" ?
                'Установть статус кроить' : 'Установть статус поворот';
        };

        const updateStatusByIds = async () => {
            DetailService.updateCutOrTurnByIds(selectedIds, status, typeStatus, "orders")
                .then(function () {
                    handleModalAlert("Статус установлен", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
            setModalStatusOpen(false);
        }
        const modalActions = [
            {name: "Установить статус кроить", type: "cut"},
            {name: "Установить статус поворот", type: "turn"},
        ]
        const handleSelectAction = (type) => {
            setOpen(false)
            setModalStatusOpen(true)
            setTypeStatus(type)
        }
        const generalTabComponents = [
            {
                tabIndex: 1, label: "Материалы",
                component: <MaterialWarehouseTable
                    data={dataMaterialWarehouse}
                    setData={setDataMaterialWarehouse}
                    nameMaterial={nameMaterial}
                    isPriceInCurrencyArrival={false}
                    isPriceInCurrencyAlternative={false}
                    isPriceInCurrencyBase={false}
                    isWarehouse={true}
                    baseIndents={baseIndents}
                    tempBaseIndents={tempBaseIndents}
                    setTempBaseIndents={setTempBaseIndents}
                    unableCut={unableCutMaterialWarehouse}
                    setUnableCut={setUnableCutMaterialWarehouse}
                    isAddCutOffButton={true}
                    isActions={true}
                    isColumnCut={true}
                    isColumnReserve={true}
                    baseCurrency={baseCurrency}
                    alternativeCurrency={alternativeCurrency}
                    material={material}
                    handleModalAlert={handleModalAlert}
                />
            },
            {
                tabIndex: 2, label: "Детали",
                component: <ComponentDetailWithFilter
                    data={data}
                    setData={setData}
                    unableCut={unableCut}
                    unableTurn={unableTurn}
                    setUnableCut={setUnableCut}
                    setUnableTurn={setUnableTurn}
                    selectedIds={selectedIds}
                    setSelectedIds={setSelectedIds}
                    modalStatusOpen={modalStatusOpen}
                    setModalStatusOpen={setModalStatusOpen}
                    status={status}
                    setStatus={setStatus}
                    typeStatus={typeStatus}
                    setTypeStatus={setTypeStatus}
                    isColumnOrder={true}
                    warehouse={'orders'}
                    expanded={true}
                    pageSize={100}
                    change={change}
                    setChange={setChange}
                    isError={isError}
                    isColumnCut={true}
                    isColumnTurn={true}
                    enableRowSelection={true}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    enableEditing={true}
                    hideHeight={true}
                    validateOversizeDetails={true}
                    errorIds={errorIds}
                    onDetailValidationChange={(positions) => {
                        setErrorIds(positions);
                        setIsError(positions.length > 0);
                    }}
                    handleModalAlert={handleModalAlert}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    viewingAvailable={false}
                />
            },
            {
                tabIndex: 3, label: "Карты раскроя",
                component: <Box
                    sx={{
                        display: 'flex',
                        gap: '1.5rem',
                        p: '0.5rem',
                        flexWrap: 'wrap',
                        flexDirection: 'column'
                    }}
                >
                    <CuttingModule
                        images={images}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        isLoading={isLoadingCuttingMap}
                        changeCuttingMap={changeCuttingMap}
                        setChangeCuttingMap={setChangeCuttingMap}
                        vectorMode={vector}
                        vectorCuttingMap={vectorCuttingMap}
                        vectorPageCount={dataMaterialWarehouseCuttingMap.length}
                        drawEdge={drawEdge}
                        fitToStripFirst={fitToStripFirst}
                        setFitToStripFirst={setFitToStripFirst}
                        fitToStripSecond={fitToStripSecond}
                        setFitToStripSecond={setFitToStripSecond}
                        dimensions={dimensions}
                        setDimensions={setDimensions}
                        combiningDrops={combiningDrops}
                        setCombiningDrops={setCombiningDrops}
                        cutDropDetail={cutDropDetail}
                        setCutDropDetail={setCutDropDetail}
                        cutFitToStripFirstDropDetail={cutFitToStripFirstDropDetail}
                        setCutFitToStripFirstDropDetail={setCutFitToStripFirstDropDetail}
                        cutFitToStripSecondDropDetail={cutFitToStripSecondDropDetail}
                        setCutFitToStripSecondDropDetail={setCutFitToStripSecondDropDetail}
                        cutCombiningDrops={cutCombiningDrops}
                        setCutCombiningDrops={setCutCombiningDrops}
                        takeAccountDimensions={takeAccountDimensions}
                        setTakeAccountDimensions={setTakeAccountDimensions}
                        cutWastes={cutWastes}
                        setCutWastes={setCutWastes}
                        cutCutOffs={cutCutOffs}
                        setCutCutOffs={setCutCutOffs}
                        cutOnlyCutOffs={cutOnlyCutOffs}
                        setCutOnlyCutOffs={setCutOnlyCutOffs}
                        cutOnlyWarehouse={cutOnlyWarehouse}
                        setCutOnlyWarehouse={setCutOnlyWarehouse}
                    />
                    <Box sx={{
                        marginRight: '10px'
                    }}>
                        <Box
                            sx={{
                                display: 'flex',
                                gap: '0.5rem',
                                paddingTop: '0.5rem',
                                paddingBottom: '0.5rem',
                                flexWrap: 'wrap',
                            }}
                        >

                            {cutButton &&
                                <ButtonAdd text={"Раскроить"} height={44} onClick={cutting}/>
                            }
                            {cancelReserveButton &&
                                <ButtonBlue icon={false} text={"Отменить резервы"} width={170} onClick={cancelReserve}/>
                            }
                            {approveButton &&
                                <ButtonAdd text={"Подтвердить карту раскроя"} height={44} width={240} onClick={approve}/>
                            }
                            {state === 'MAPS_APPROVED' &&
                                <ButtonBlue icon={false} text={"Отменить карту раскроя"} width={220} onClick={cancel}/>
                            }
                        </Box>
                        {/*<Box
                    sx={{display: 'flex', gap: '0.5rem', flexWrap: 'wrap'}}
                >
                    {state === 'MAPS_APPROVED' &&
                        <Button sx={{marginRight: '0px'}} variant="contained" color="secondary"
                            onClick={cutting}>Перекроить текущий лист</Button>}
                    {state === 'MAPS_APPROVED' &&
                        <Button sx={{marginRight: '10px'}} variant="contained" color="secondary"
                            onClick={cutting}>Перезаписать текущий лист</Button>}
                </Box>*/}
                    </Box>
                    <Typography
                        sx={{
                            fontWeight: 700
                        }}
                        component="h3"
                    >
                        Резерв текущей карты
                    </Typography>
                    <ReservationTableCuttingItem
                        pageSize={100}
                        enableGrouping={false}
                        columnGrouping={['articleNumber']}
                        isColumnMaterialWarehouse={true}
                        expanded={false}
                        data={currentOrdersCuttingMapDataObjectReserve}
                        setData={setCurrentOrdersCuttingMapDataObjectReserve}
                        nameMaterial={nameMaterial}
                        isCalculation={isCalculation}
                        handleModalAlert={handleModalAlert}
                    />
                    <Typography
                        sx={{
                            fontWeight: 700
                        }}
                        variant="body1" component="h3">
                        Детали текущей карты
                    </Typography>
                    <CurrentMapDetails
                        data={currentOrdersCuttingMapDataObjectDetails}
                        setData={setCurrentOrdersCuttingMapDataObjectDetails}
                        tableOptions={tableOptions}
                        tableOptionsHandle={tableOptionsHandle}
                    />
                </Box>
            }, {
                tabIndex: 4, label: "Настройки",
                component: <SettingsCuttingModule
                    material={material}
                    setSupplierId={setSupplierId}
                    supplierId={supplierId}
                    supplierList={supplierList}
                    cutDefault={cutDefault}
                    setCutDefault={setCutDefault}
                    setDrawEdge={setDrawEdge}
                    drawEdge={drawEdge}
                    limitNumberTurns={limitNumberTurns}
                    setLimitNumberTurns={setLimitNumberTurns}
                    rotatePartInsideStrip={rotatePartInsideStrip}
                    setRotatePartInsideStrip={setRotatePartInsideStrip}
                    alternativeServer={alternativeServer}
                    setAlternativeServer={setAlternativeServer}
                    cutWeight={cutWeight}
                    setCutWeight={setCutWeight}
                    trimmingLeft={trimmingLeft}
                    setTrimmingLeft={setTrimmingLeft}
                    trimmingRight={trimmingRight}
                    setTrimmingRight={setTrimmingRight}
                    trimmingBottom={trimmingBottom}
                    setTrimmingBottom={setTrimmingBottom}
                    trimmingTop={trimmingTop}
                    setTrimmingTop={setTrimmingTop}
                    minBalanceUpToWholeSheet={minBalanceUpToWholeSheet}
                    setMinBalanceUpToWholeSheet={setMinBalanceUpToWholeSheet}
                    minACutOff={minACutOff}
                    setMinACutOff={setMinACutOff}
                    minBCutOff={minBCutOff}
                    setMinBCutOff={setMinBCutOff}
                    isLoading={isLoading}
                    percentCutOff={percentCutOff}
                    setPercentCutOff={setPercentCutOff}
                    percentWaste={percentWaste}
                    setPercentWaste={setPercentWaste}
                    count={count}
                    setCount={setCount}
                />
            }, {
                tabIndex: 5, label: "Настройки обрезков",
                component: <> <Typography
                    sx={{
                        marginBottom: '3px',
                    }}
                    variant="body1" component="h3">
                    Настройки получаемых обрезков после раскроя
                </Typography>
                    <SettingsCutOffCuttingModule
                        trimmingLeftCutOff={trimmingLeftCutOff}
                        setTrimmingLeftCutOff={setTrimmingLeftCutOff}
                        trimmingRightCutOff={trimmingRightCutOff}
                        setTrimmingRightCutOff={setTrimmingRightCutOff}
                        trimmingTopCutOff={trimmingTopCutOff}
                        setTrimmingTopCutOff={setTrimmingTopCutOff}
                        trimmingBottomCutOff={trimmingBottomCutOff}
                        setTrimmingBottomCutOff={setTrimmingBottomCutOff}
                        isLoading={isLoading}
                    /></>
            }, {
                tabIndex: 6,
                label: "Неиспользованные детали",
                tabLabelVariant: "alert",
                component: <Box
                    sx={{
                        display: 'flex',
                        gap: '0.5rem',
                        p: '0.5rem',
                        flexWrap: 'wrap',
                        flexDirection: 'column'
                    }}
                >
                    <ComponentDetailWithFilter
                        key="working-cutting-map-not-used-details"
                        data={notUsedDetails}
                        setData={setNotUsedDetails}
                        unableCut={unableCut}
                        unableTurn={unableTurn}
                        setUnableCut={setUnableCut}
                        setUnableTurn={setUnableTurn}
                        selectedIds={selectedIds}
                        setSelectedIds={setSelectedIds}
                        modalStatusOpen={modalStatusOpen}
                        setModalStatusOpen={setModalStatusOpen}
                        status={status}
                        setStatus={setStatus}
                        typeStatus={typeStatus}
                        setTypeStatus={setTypeStatus}
                        isColumnOrder={true}
                        warehouse={'orders'}
                        expanded={true}
                        pageSize={100}
                        change={change}
                        setChange={setChange}
                        isError={isError}
                        hideQuantity={true}
                        handleModalAlert={handleModalAlert}
                        tableOptions={tableOptions}
                        tableOptionsHandle={tableOptionsHandle}
                    />
                </Box>
            }, {
                tabIndex: 7, label: "Резервы",
                component: <ReservationTableCuttingItem
                    pageSize={100}
                    enableGrouping={false}
                    columnGrouping={['articleNumber']}
                    isColumnMaterialWarehouse={true}
                    expanded={false}
                    data={dataMaterialReserve}
                    setData={setDataMaterialReserve}
                    nameMaterial={nameMaterial}
                    isCalculation={isCalculation}
                    enableRowSelection={true}
                    handleModalAlert={handleModalAlert}
                    showRowNumber={true}
                />
            },]
        return (
            <Box sx={{padding: "0 30px"}}>
                <BreadcrumbsComponent
                    page={`${number}`}
                    path={[
                        {name: "Главная", href: "/"},
                        {name: "Карты раскроя", href: "/organization/working-cutting-maps"},
                    ]}/>
                <Box sx={{display: "flex", flexDirection: "column", gap: "32px"}}>
                    <Box sx={{display: "flex", justifyContent: "space-between"}}>
                        <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                            {number} ({nameMaterial})
                        </Typography>
                        <Box sx={{display: 'flex', gap: "10px"}}>
                            {!isCalculation && <ButtonCreate
                                text={"Заявки на раскрой"}
                                width={160}
                                icon={false}
                                onClick={() => navigate('/organization/requests-cutting')}
                            />}
                            {isCalculation && <ButtonCreate
                                text={"Рас. заявки на раскрой"}
                                width={200}
                                icon={false}
                                onClick={() => navigate('/organization/requests-cutting/Calculation')}
                            />}
                            {!isCalculation && <ButtonCreate
                                text={"Оптимизации"}
                                width={120}
                                icon={false}
                                onClick={() => navigate('/organization/optimizations')}
                            />}
                            {isCalculation && <ButtonCreate
                                text={"Рас.оптимизации"}
                                width={150}
                                icon={false}
                                onClick={() => navigate('/organization/optimizations-calculation')}
                            />}
                            {!isCalculation && <ButtonCreate
                                text={"Планы"}
                                width={70}
                                icon={false}
                                onClick={() => navigate('/organization/plans')}
                            />}
                            {!isCalculation && <ButtonCreate
                                text={"Карты раскроя"}
                                width={130}
                                icon={false}
                                onClick={() => navigate('/organization/working-cutting-maps')}
                            />}
                            {isCalculation && <ButtonCreate
                                text={"Рас. карты раскроя"}
                                width={170}
                                icon={false}
                                onClick={() => navigate('/organization/working-cutting-maps-calculation')}
                            />}
                        </Box>
                    </Box>

                    <ButtonGroupTabBar activeTab={tab}>
                        {generalTabComponents.map(({tabIndex, label, tabLabelVariant}, index) => {
                            const buttonVisible = ((tabIndex === 1 || tabIndex === 4 || tabIndex === 5) && !(isArchive || isCalculationArchive))
                                || (tabIndex === 2 && !(isCalculationArchive)) || tabIndex === 3 || tabIndex === 7 || (tabIndex === 6 && notUsedDetailsIsEmpty())
                            return buttonVisible &&
                                <Button
                                    key={tabIndex}
                                    tabIndex={tabIndex}
                                    data-tab-label={tabLabelVariant || undefined}
                                    onClick={() => handleChangeTab(tabIndex)}
                                >
                                    <CheckIcon/>
                                    {label}
                                </Button>
                        })}
                    </ButtonGroupTabBar>
                    {generalTabComponents.find(component => component.tabIndex === tab)?.component}
                </Box>
                {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: "88px",
                    display: 'flex',
                    justifyContent: "center",
                    alignItems: 'center',
                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                }} component="footer">
                    <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpen(true)}/>
                </Paper>}
                <ModalSelectAction
                    open={open}
                    reset={() => setOpen(false)}
                    submit={handleSelectAction}
                    modalActions={modalActions}
                />
                <ModalAlert
                    data={alertData}
                    onClose={() => setAlertData((alert) => ({...alert, open: false}))}
                />
                <ModalOpenSetValuesCutOrTurnDetail
                    title={setTitleModalOpenMethod(typeStatus)}
                    modalOpen={modalStatusOpen}
                    handleClose={() => setModalStatusOpen(false)}
                    setValue={setStatus}
                    handleSubmit={updateStatusByIds}
                />
            </Box>
        );
    }
;

export default WorkingCuttingMapItem;
